import { gql } from "@apollo/client";
import { enforcementIntentSummaryFragment, EnforcementIntentSummary } from "../fragments/enforcementIntentSummary";

// The voided list deliberately hides internal_review voids. Note the _or:
// `_neq` alone silently drops rows where voided_reason IS NULL too, because SQL
// `NULL <> 'internal_review'` evaluates to NULL rather than true — so a notice
// voided with no reason at all would vanish from the list entirely instead of
// showing up for triage. See AUT-5544.
//
// `internal_review` is intentionally UNQUOTED: enforcement_intent_voided_reason
// is tracked with `is_enum: true`, so Hasura exposes the column as a GraphQL
// enum and a bare literal is the required syntax. Quoting it breaks the query.
export const GET_VOIDED_ENFORCEMENT_INTENTS = gql`
  query GetVoidedEnforcementIntents($offset: Int = 0) {
    enforcementIntents: enforcement_intent(
      where: {
        voided_at: { _is_null: false }
        _or: [{ voided_reason: { _is_null: true } }, { voided_reason: { _neq: internal_review } }]
      }
      offset: $offset
      limit: 100 #TODO: add order by
    ) {
      ...enforcementIntentSummaryFragment
    }
  }
  ${enforcementIntentSummaryFragment}
`;

export interface GetVoidedEnforcementIntentsVars {
  offset: number;
}

export interface GetVoidedEnforcementIntentsData {
  enforcementIntents: EnforcementIntentSummary[];
}

export const GET_VOIDED_ENFORCEMENT_INTENTS_OVERVIEW = gql`
  query GetVoidedEnforcementIntentsOverview(
    $daysAgo365: timestamptz!
    $daysAgo30: timestamptz!
    $daysAgo7: timestamptz!
  ) {
    past365Days: enforcement_intent_aggregate(
      where: {
        voided_at: { _is_null: false, _gte: $daysAgo365 }
        _or: [{ voided_reason: { _is_null: true } }, { voided_reason: { _neq: internal_review } }]
      }
    ) {
      aggregate {
        count
      }
    }
    past30Days: enforcement_intent_aggregate(
      where: {
        voided_at: { _is_null: false, _gte: $daysAgo30 }
        _or: [{ voided_reason: { _is_null: true } }, { voided_reason: { _neq: internal_review } }]
      }
    ) {
      aggregate {
        count
      }
    }
    past7Days: enforcement_intent_aggregate(
      where: {
        voided_at: { _is_null: false, _gte: $daysAgo7 }
        _or: [{ voided_reason: { _is_null: true } }, { voided_reason: { _neq: internal_review } }]
      }
    ) {
      aggregate {
        count
      }
    }
  }
`;

export interface GetVoidedEnforcementIntentsOverviewVars {
  daysAgo365: string;
  daysAgo30: string;
  daysAgo7: string;
}

export interface GetVoidedEnforcementIntentsOverviewData {
  past365Days: {
    aggregate: {
      count: number;
    };
  };
  past30Days: {
    aggregate: {
      count: number;
    };
  };
  past7Days: {
    aggregate: {
      count: number;
    };
  };
}
